import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20composition%20with%20soft%20cream%20linen%20fabric%20draped%20elegantly%2C%20scattered%20minimalist%20fashion%20accessories%20including%20a%20leather%20watch%20strap%20and%20sunglasses%20on%20warm%20sand%20colored%20surface%2C%20gentle%20side%20window%20lighting%20creating%20soft%20shadows%2C%20high%20end%20catalog%20aesthetic%2C%20refined%20neutral%20palette%2C%20artistic%20yet%20commercial%20photography%20style%2C%20sophisticated%20product%20presentation&width=1800&height=1200&seq=hero-bg-v2&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white/90 text-xs font-medium mb-4 tracking-wide">
            UPDATED 2026 GUIDES
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 drop-shadow-sm">
            BaseTao Spreadsheet: Complete Review, Guides, Shipping Tools &amp; Buyer Resources
          </h1>
          <p className="text-white/80 text-sm md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover everything about BaseTao Spreadsheet including reviews, shipping costs, warehouse guides, discount codes, comparison charts, and expert buying strategies.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/article/basetao-shopping-guide"
              className="w-full sm:w-auto px-6 py-3 rounded-xl bg-primary-500 text-white hover:bg-primary-600 text-sm md:text-base font-semibold transition-all cursor-pointer whitespace-nowrap"
            >
              Explore BaseTao Spreadsheet Guides
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-6 py-3 rounded-xl bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 border border-white/20 text-sm md:text-base font-medium transition-all cursor-pointer whitespace-nowrap"
            >
              Get Latest BaseTao Updates
            </a>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-8 text-white/70 text-xs">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Updated 2026 Guides
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Independent Research
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Shipping Cost Analysis
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-primary-400"></i> Complete Buyer Resources
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}